import { render, staticRenderFns } from "./TarefaAprovacaoSolicitanteModal.vue?vue&type=template&id=7ff9be80"
import script from "./TarefaAprovacaoSolicitanteModal.vue?vue&type=script&lang=js"
export * from "./TarefaAprovacaoSolicitanteModal.vue?vue&type=script&lang=js"
import style0 from "./TarefaAprovacaoSolicitanteModal.vue?vue&type=style&index=0&id=7ff9be80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports